import { useIntl } from 'react-intl';

const DEFAULT_ERROR_MESSAGE = 'Invalid value';

export const useValidationMessage = (): ((message?: string) => string) => {
  const { formatMessage } = useIntl();

  return (message?: string): string =>
    formatMessage(
      {
        id: message || 'errors.invalid',
        defaultMessage: DEFAULT_ERROR_MESSAGE,
      },
      {},
    );
};
